import React, { useEffect, useRef, useState } from 'react';
import { classNames } from '../../utils/classNames';
import moment from 'moment';
import { useGenerateSpeechMutation } from '../../store/chatbox/ttsApi';
import Loading from '../../shared/Loading';
import { useTheme } from '../../theme-context';

type TActive = 'copy' | 'thumb-up' | 'thumb-down' | 'save'

const MessageActions = ({
    chatId,
    message,
    liked,
    disliked,
    favorite,
    updatedAt
}: {
    chatId: string,
    message: string,
    topicId?: string,
    liked?: boolean,
    disliked?: boolean,
    favorite?: boolean,
    updatedAt: string
}) => {
    const [getVoice, { isLoading: isVoiceLoading }] = useGenerateSpeechMutation();
    const { theme } = useTheme();
    const [active, setActive] = useState<TActive[]>([]);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const audioRef = useRef<HTMLAudioElement | null>(null);

    useEffect(() => {
        if (liked)
            setActive([...active, 'thumb-up'])
        if (disliked)
            setActive([...active, 'thumb-down'])
    }, [liked, disliked, favorite])

    const stripHtml = (html: string): string => {
        const div = document.createElement('div');
        div.innerHTML = html;
        return div.textContent || div.innerText || '';
    };

    const speakText = async () => {
        const plainText = stripHtml(message);
        if (isVoiceLoading) return

        if (audioRef.current && !audioRef.current.paused) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
            setIsSpeaking(false);
            return;
        }

        try {
            const response = await getVoice(plainText).unwrap()
            const audioBlob = response;
            const audioUrl = URL.createObjectURL(audioBlob);
            const audio = new Audio(audioUrl);
            audioRef.current = audio;

            audio.play();
            setIsSpeaking(true);

            audio.addEventListener('ended', () => {
                setIsSpeaking(false);
            });
        } catch (e) {
            console.error(e);
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(stripHtml(message));
            setActive((prev) => [...prev, 'copy']);
            setTimeout(() => {
                setActive((prev) => prev.filter((ac) => ac !== 'copy'));
            }, 2000);
        } catch (err) {
            console.error('copy error:', err);
        }
    };

    const btnClassNames = 'p-1 hover:bg-gray-200 rounded-md dark:hover:bg-gray-600';
    return (
        <div className='mt-1 flex flex-row items-center'>
            <p className='text-gray-400 font-semibold text-xs mr-2'>{moment(updatedAt).format('h:mm A')}</p>
            {/* <p className='mb-1'>Let me know how you find this response.</p> */}
            <button onClick={handleCopy} className={classNames(btnClassNames)} title='copy' type='button'>
                {active.includes('copy') ? <img alt='copy' src={theme === 'dark' ? '/svg/icons/copy-white.svg' : '/svg/icons/active/copy-active.svg'} className='object-contain w-[14px]' /> : <img alt='copy' src={theme === 'dark' ? '/svg/icons/copy-white.svg' : '/svg/icons/copy.svg'} className='object-contain w-4' />}
            </button>
            {active.includes('copy') && (
                <span className='text-[11px] font-medium text-emerald-600 dark:text-emerald-400 mr-1'>
                    Copied
                </span>
            )}
            {/* <button onClick={handleThumbUp} className={classNames(btnClassNames, isLoading ? 'opacity-50' : '')} disabled={isReactLoading} title='thumbs up' type='button'>
				{active.includes('thumb-up') ? <img alt='thumb up' src={theme === 'dark' ? '/svg/icons/active/thumb-up-white.svg' : '/svg/icons/active/thumb-up.svg'} className='object-contain w-[22px]' /> : <img alt='thumb up' src={theme === 'dark' ? '/svg/icons/thumb-up-white.svg' : '/svg/icons/thumb-up.svg'} className='object-contain w-[22px]' />}
			</button>
			<button onClick={handleThumbDown} className={classNames(btnClassNames, isLoading ? 'opacity-50' : '')} disabled={isReactLoading} title='thumbs down' type='button'>
				{active.includes('thumb-down') ? <img alt='thumb down' src={theme === 'dark' ? '/svg/icons/active/thumb-down-white.svg' : '/svg/icons/active/thumb-down.svg'} className='object-contain w-[22px]' /> : <img alt='thumb up' src={theme === 'dark' ? '/svg/icons/thumb-down-white.svg' : '/svg/icons/thumb-down.svg'} className='object-contain w-[22px]' />}
			</button>
			<button onClick={handleSave} className={classNames(btnClassNames, isLoading ? 'opacity-50' : '')} disabled={isLoading} title='save' type='button'>
				{active.includes('save') ? <img alt='save' src={theme === 'dark' ? '/svg/icons/active/save-active-white.svg' : '/svg/icons/active/save-active.svg'} className='object-contain w-[22px]' /> : <img alt='thumb up' src={theme === 'dark' ? '/svg/icons/save-white.svg' : '/svg/icons/save.svg'} className='object-contain w-[22px]' />}
			</button> */}
            <button onClick={speakText} className={btnClassNames} style={{ opacity: isVoiceLoading ? '0.5' : '1' }} title='Read aloud'>
                {isVoiceLoading ? <Loading /> : isSpeaking ? <img alt='audio' src={theme === 'dark' ? '/svg/icons/active/audio-active-white.svg' : '/svg/icons/active/audio-active.svg'} className='object-contain w-[14px]' /> : <img alt='audio' src={theme === 'dark' ? '/svg/icons/audio-white.svg' : '/svg/icons/audio.svg'} className='object-contain w-4' />}
            </button>
        </div>
    )
}

export default MessageActions;